/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjectGroupSimple,
    ReadOnlyMonitoredObjectGroupSimpleFromJSON,
    ReadOnlyMonitoredObjectGroupSimpleFromJSONTyped,
    ReadOnlyMonitoredObjectGroupSimpleToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20023
 */
export interface InlineResponse20023 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20023
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20023
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20023
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObjectGroupSimple>}
     * @memberof InlineResponse20023
     */
    results: Array<ReadOnlyMonitoredObjectGroupSimple>;
}

export function InlineResponse20023FromJSON(json: any): InlineResponse20023 {
    return InlineResponse20023FromJSONTyped(json, false);
}

export function InlineResponse20023FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20023 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjectGroupSimpleFromJSON)),
    };
}

export function InlineResponse20023ToJSON(value?: InlineResponse20023 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjectGroupSimpleToJSON)),
    };
}


